module.exports = __webpack_public_path__ + "img/manage.fbe431a9.svg";